export const watch = {
  hoaId() {
    this.reload()
  },
  statusFilter() {
    this.reload()
  }
}
